import { useEffect, useState } from "react";

export const useMobile = () => {
  const [mobile, setMobile] = useState(window.innerWidth < 990);

  const handleWindowSizeChange = () => {
    setMobile(window.innerWidth < 990);
  };

  useEffect(() => {
    handleWindowSizeChange();
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  return mobile;
};
